import script from "./ScreenMirrorMarks.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScreenMirrorMarks.vue?vue&type=script&setup=true&lang=ts"

import "./ScreenMirrorMarks.vue?vue&type=style&index=0&id=acddc95c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acddc95c"]])

export default __exports__